import { useState } from "react"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { toast } from "@/hooks/use-toast"
import i18n from "@/i18n"
import { subscriptionDownloadLetterPDF } from "@/services"
const orderReceiptPDF = async (orderId: string) => {
  const url = `${ENDPOINTS.ORDER}/${orderId}/download_letter`
  const { data } = await api.get(url, {
    responseType: "blob",
  })
  return data
}
type useDownloadCancellationLetterProps = {
  subscriptionId?: string
  billingCycle?: number
  orderId?: string
}
const useDownloadCancellationLetter = (
  params: useDownloadCancellationLetterProps
) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const handleDownload = async () => {
    setIsDownloading(true)
    try {
      let response = null
      if (params?.orderId) {
        response = await orderReceiptPDF(params?.orderId)
      } else {
        response = await subscriptionDownloadLetterPDF(
          params.subscriptionId!,
          params.billingCycle!
        )
      }
      const urlArchive = URL.createObjectURL(
        new Blob([response])
      )
      const link = document.createElement("a")
      link.href = urlArchive
      link.setAttribute(
        "download",
        `${params?.subscriptionId}-${params?.billingCycle}-${params?.orderId}-carta-cancelamento.pdf`
      )
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(urlArchive)
      toast({
        title: i18n.t("files.downloadSuccess"),
        variant: "success",
      })
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast({
          title:
            error.message || i18n.t("files.downloadError"),
          variant: "destructive",
        })
      } else {
        toast({
          title: i18n.t("files.downloadError"),
          variant: "destructive",
        })
      }
      return
    } finally {
      setIsDownloading(false)
    }
  }
  return {
    handleDownload,
    isDownloading,
  }
}
export default useDownloadCancellationLetter
